export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Confirmation", larga: "Booking confirmation", porque: "Your account-wide setting is being used, not one specific to this property." },
    bienvenida: { etiqueta: "Welcome", larga: "Welcome message", porque: "Right now the default welcome message goes out, and it isn't yours." },
    checkin: { etiqueta: "Check-in", larga: "Check-in delivery", porque: "Right now it goes out at the default time, which may not suit you." },
    horas: { etiqueta: "Hours", larga: "Check-in and check-out times", porque: "Without your hours, guests who ask are given the default ones." },
    cerradura: { etiqueta: "Access", larga: "Lock and access", porque: "Your guest reaches the door with no idea how to open it." },
    servicios: { etiqueta: "Services", larga: "Property services", porque: "Neither the booking engine nor the agent knows what you offer." },
    politicas: { etiqueta: "Rules", larga: "Policies and rules", porque: "Your guest agrees to default rules, not yours." },
  },
  titular: {
    listo: "Everything is ready",
    unoAMedias: "Your property is half set up",
    variosAMedias: "Your properties are half set up",
    casi: "You're almost done",
  },
  consecuencia: {
    bienvenida: "In the meantime your guests get the default welcome message, which isn't yours.",
    cerradura: "In the meantime some guests would reach the door with no idea how to open it.",
    politicas: "In the meantime your guests agree to default rules, not yours.",
    generico: "In the meantime the default settings are being used, not yours.",
  },
  explicacion: {
    listoUno: "Your property can now take guests.",
    listoVarios: "Your {n} properties can now take guests.",
    ajustesFinos: "The finer settings — rates, channels, experiences — are waiting in each listing whenever you want them.",
    faltaUno: "1 property left to finish.",
    faltanVarios: "{n} properties left to finish.",
  },
  resumen: {
    unAlojamiento: "1 property",
    nAlojamientos: "{n} properties",
    unoPorPreparar: "1 to set up",
    nPorPreparar: "{n} to set up",
    listos: "{listos} ready",
  },
  anillo: {
    rotulo: "set up",
    ariaCorta: "{n}% set up",
    ariaLarga: "{n}% of the setup completed",
  },
  cifras: {
    listos: "ready ·",
    ajustes: "settings done",
    ariaAjustes: "{hechas} of {total} settings done",
    marcador: "{hechas} of {total}",
  },
  ventana: {
    titulo: "Close this notice?",
    texto: "It will stop appearing in the panel, even if something is still unset.",
    notaAntes: "You can bring it back any time from",
    notaRuta: "Customise → Show the setup notice",
    cancelar: "Cancel",
    ocultar: "Close",
  },
  acciones: {
    verQueFalta: "See what's missing",
    buscar: "Search property",
    sinResultados: "No pending property is called that.",
    verClaro: "Switch to light",
    verOscuro: "Switch to dark",
    ampliar: "Expand",
    ampliarAria: "Expand the notice",
    minimizar: "Minimise",
    minimizarAria: "Minimise the notice",
    entendido: "Got it",
    entendidoAria: "Got it, close the notice",
    ocultar: "Close",
    ocultarAria: "Close the setup notice",
    empezar: "Start",
    continuar: "Continue",
    hecho: "done",
    teToca: "Up next:",
    unidades: "{n} units",
  },
};
